import { render } from "./filters-icon.vue?vue&type=template&id=10e81fd0"
const script = {}

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__